import React from 'react';
import ModalLayout from '../layouts/ModalLayout';
import CancelSaveButton from '../misc/CancelSaveButton';

export interface SimpleWarningModalProps {
  open: boolean;
  title: string;
  description: string;
  button: string;
  cancel?: string;
  onCancel?: () => void;
  onContinue?: () => void;
  saveClassName?: string;
  cancelClassName?: string;
}

interface WarningModalProps {
  open: boolean;
  setOpen: (bool: boolean) => void;
  onContinue?: () => void;
  onCancel?: () => void;
  title: string;
  description: string;
  button?: string;
  cancel?: string;
  saveClassName?: string;
  cancelClassName?: string;
}
export default function WarningModal({
  open,
  setOpen,
  onContinue = () => {},
  onCancel = () => {},
  title,
  description,
  button,
  cancel,
  saveClassName,
  cancelClassName,
}: WarningModalProps): JSX.Element {
  return (
    <ModalLayout
      open={open}
      setOpen={setOpen}
      className="relative transform overflow-hidden rounded-[20px] bg-secondary-50 px-6 py-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
      <div className="mb-4 flex flex-col gap-2">
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
      <div className="flex justify-end">
        <CancelSaveButton
          onCancel={() => {
            onCancel();
            setOpen(false);
          }}
          onSave={() => {
            onContinue();
            setOpen(false);
          }}
          buttonText={button}
          cancelText={cancel}
          saveClassName={saveClassName}
          cancelClassName={cancelClassName}
        />
      </div>
    </ModalLayout>
  );
}
